/**
 * Full-page navigation, in one place so tests can mock it (jsdom doesn't navigate, and its
 * window.location can't be replaced).
 */
export const goToUrl = url => window.location.assign(url);
